import { createFileRoute } from '@tanstack/react-router'
import ConceptPreliminaryEditions from 'Concept/components/Concept/Sections/ConceptPreliminaryEditions'

import { Guard } from '../../../-guard'

export const Route = createFileRoute('/concept/$conceptId/productions/')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <ConceptPreliminaryEditions />
        </Guard>
    ),
})
